import { ComponentWithAs, Icon, IconProps } from '@chakra-ui/react'

const IconComp: ComponentWithAs<'svg', IconProps> = ({
  children,
  ...props
}) => {
  return (
    <Icon {...props}>
      <path
        d="M645.8 544.9L415.6 240 195.1 394c-20.8 14.5-25.2 43.4-9.8 63.5L327.5 643l318.3-98.1z"
        fill="#8F3694"
      />
      <path
        d="M645.8 544.9L415.6 240 595 120.8c21.3-14.1 49.9-8.4 64.2 12.7l141.5 209.7-154.9 201.7z"
        fill="#8F3694"
      />
      <path
        d="M800.7 343.2l-0.1-0.2v0.2zM562.2 289c7.8-14.9 21.9-25.6 38.4-29.1l125.9-26.7-74.6-110.6c-11.2-16.5-31.2-24.7-50.7-20.8l-286.4 58 177.5 262.9L562.2 289z"
        fill="#CAC134"
      />
      <path
        d="M377.5 357.4L492 423.2l0.3-0.5-177.5-262.9-140.3 232c-10.5 17.4-9.3 39.4 3.1 55.6l47.8 62.4 104.9-142.4c10.9-14.9 31.2-19.2 47.2-10zM492.4 423.5l0.2-0.2-0.3 0.1zM327.5 643l7.8-10.5-7.8 10.4zM816.8 214l-90.3 19.2L800.6 343l34-109.5c3.5-11.2-6.4-21.9-17.8-19.5z"
        fill="#FFBA3B"
      />
      <path d="M492.6 423.3l308-80.1-308 80z" fill="#FE506B" />
      <path
        d="M600.6 259.9c-16.5 3.5-30.5 14.2-38.4 29.1l-70 133.7 0.3 0.5 308-80v-0.2l-74.1-109.9-125.8 26.8z"
        fill="#CAC134"
      />
      <path
        d="M600.6 259.9c-16.5 3.5-30.5 14.2-38.4 29.1l-70 133.7 0.3 0.5 308-80v-0.2l-74.1-109.9-125.8 26.8z"
        fill="#FF7C20"
      />
      <path d="M492.3 422.7l-0.3 0.5 0.3 0.2 0.3-0.1v-0.1z" fill="#FFBA3B" />
      <path d="M492.3 422.7l-0.3 0.5 0.3 0.2 0.3-0.1v-0.1z" fill="#FE506B" />
      <path
        d="M201.7 541.7c-9.6 13-5.4 31.5 8.9 39L327.4 643v-0.1L225.3 509.7l-23.6 32z"
        fill="#FFBA3B"
      />
      <path d="M492.8 423.7l-0.4-0.2-157.1 209z" fill="#FE506B" />
      <path
        d="M491.9 423.5l0.1-0.2-114.5-65.8c-16-9.2-36.3-4.9-47.2 9.9l-105 142.3 102.1 133.2 7.9-10.4 157.1-209.1-0.2-0.1-0.3 0.2z"
        fill="#FFBA3B"
      />
      <path
        d="M491.9 423.5l0.1-0.2-114.5-65.8c-16-9.2-36.3-4.9-47.2 9.9l-105 142.3 102.1 133.2 7.9-10.4 157.1-209.1-0.2-0.1-0.3 0.2z"
        fill="#FF7C20"
      />
      <path d="M492.3 423.4l-0.3-0.2-0.1 0.3z" fill="#FFBA3B" />
      <path d="M492.3 423.4l-0.3-0.2-0.1 0.3z" fill="#FE506B" />
      <path d="M492.3 423.4l-0.3-0.2-0.1 0.3z" fill="#FE506B" />
      <path
        d="M595 680.5l-250.3 83.8c-14.4 4.9-29-6.7-27.5-21.8l10.3-99.5 318.3-98.1-14 94.7c-4.3 19-18.2 34.5-36.8 40.9z"
        fill="#FFBA3B"
      />
      <path
        d="M851.5 334.6L745.8 456c-7.2 9-15.5 17-24.7 23.9l-75.5 65.2 154.9-201.8 42.2-19.7c7-3.3 13.6 5 8.8 11z"
        fill="#FFBA3B"
      />
      <path
        d="M267.2 849a278.1 72.4 0 1 0 556.2 0 278.1 72.4 0 1 0-556.2 0Z"
        fill="#8F3694"
      />
      <path
        d="M511.4 669.9l14.7-5.6c5.3-2.1 11.4-1 15.8 2.7l22.6 19.2c8.6 7.3 7 21-3.1 26l-13.6 6.8c-5.6 2.8-12.4 2-17.2-2.1l-23.7-20.3c-9.1-7.9-6.5-22.4 4.5-26.7zM624.1 838.6l11-6.2c4-2.3 9-2.9 13.1-1.8l21 6.1c8 2.3 8.7 10.4 1.3 15.4l-10 6.7c-4.1 2.8-9.7 3.7-14.2 2.4l-22.1-6.6c-8.3-2.5-8.4-11.3-0.1-16z"
        fill="#FE506B"
      />
    </Icon>
  )
}
IconComp.defaultProps = {
  viewBox: '0 0 1024 1024',
  boxSize: '220px',
}

export default IconComp
